import React from 'react';

const SplatterLoading = ({ message = 'Loading...', fullScreen = false }) => {
  const containerClass = fullScreen
    ? 'fixed inset-0 z-50 flex items-center justify-center bg-black'
    : 'flex items-center justify-center py-12';

  return (
    <div className={containerClass}>
      <div className="relative">
        {/* Animated Splatter Effects */}
        <div className="relative w-48 h-48">
          {/* Center drip */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="splatter-drip splatter-purple"></div>
          </div>
          
          {/* Orbiting splatters */}
          <div className="splatter-orbit splatter-orbit-1">
            <div className="splatter-dot splatter-green"></div>
          </div>
          <div className="splatter-orbit splatter-orbit-2">
            <div className="splatter-dot splatter-purple"></div>
          </div>
          <div className="splatter-orbit splatter-orbit-3">
            <div className="splatter-dot splatter-green"></div>
          </div>
          <div className="splatter-orbit splatter-orbit-4">
            <div className="splatter-dot splatter-purple"></div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="text-center mt-8">
          <p className="text-lime-400 text-lg font-semibold animate-pulse">
            {message}
          </p>
          <div className="flex justify-center gap-1 mt-2">
            <span className="inline-block w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
            <span className="inline-block w-2 h-2 bg-lime-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
            <span className="inline-block w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
          </div>
        </div>

        {/* CSS Animations */}
        <style jsx>{`
          /* Drip animation in center */
          .splatter-drip {
            width: 40px;
            height: 60px;
            background: linear-gradient(180deg, #9333ea 0%, #9333ea 60%, transparent 100%);
            border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
            animation: drip 1.5s ease-in-out infinite;
            position: relative;
          }

          .splatter-drip::before {
            content: '';
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            width: 50px;
            height: 50px;
            background: #9333ea;
            border-radius: 50%;
            animation: pulse-splatter 1.5s ease-in-out infinite;
          }

          @keyframes drip {
            0%, 100% {
              transform: scaleY(1);
              opacity: 1;
            }
            50% {
              transform: scaleY(1.3);
              opacity: 0.8;
            }
          }

          @keyframes pulse-splatter {
            0%, 100% {
              transform: translateX(-50%) scale(1);
              opacity: 1;
            }
            50% {
              transform: translateX(-50%) scale(1.2);
              opacity: 0.7;
            }
          }

          /* Orbiting splatter dots */
          .splatter-orbit {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);
          }

          .splatter-orbit-1 {
            animation: orbit 3s linear infinite;
          }

          .splatter-orbit-2 {
            animation: orbit 3s linear infinite;
            animation-delay: -0.75s;
          }

          .splatter-orbit-3 {
            animation: orbit 3s linear infinite;
            animation-delay: -1.5s;
          }

          .splatter-orbit-4 {
            animation: orbit 3s linear infinite;
            animation-delay: -2.25s;
          }

          @keyframes orbit {
            from {
              transform: translate(-50%, -50%) rotate(0deg);
            }
            to {
              transform: translate(-50%, -50%) rotate(360deg);
            }
          }

          .splatter-dot {
            position: absolute;
            top: 0;
            left: 50%;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            transform: translateX(-50%);
            animation: splatter-pop 1.5s ease-in-out infinite;
          }

          .splatter-purple {
            background: linear-gradient(135deg, #9333ea, #a855f7);
            box-shadow: 0 0 20px rgba(147, 51, 234, 0.6);
          }

          .splatter-green {
            background: linear-gradient(135deg, #84cc16, #a3e635);
            box-shadow: 0 0 20px rgba(132, 204, 22, 0.6);
          }

          @keyframes splatter-pop {
            0%, 100% {
              transform: translateX(-50%) scale(1);
            }
            50% {
              transform: translateX(-50%) scale(1.5);
            }
          }

          /* Drip trail effect */
          .splatter-drip::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 8px;
            height: 20px;
            background: linear-gradient(180deg, #9333ea, transparent);
            border-radius: 0 0 50% 50%;
            animation: drip-trail 1.5s ease-in-out infinite;
          }

          @keyframes drip-trail {
            0%, 100% {
              opacity: 0;
              transform: translateX(-50%) translateY(0);
            }
            50% {
              opacity: 1;
              transform: translateX(-50%) translateY(10px);
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default SplatterLoading;
